import { makeStyles } from 'tss-react/mui';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()((theme) => ({
  sectionContainer: {
    wordWrap: 'break-word'
  },
  noWordBreak: {
    whiteSpace: 'nowrap'
  },
  modalTitle: {
    fontSize: '18px',
  },
  patientName: {
    fontSize: '16px'
  },
  fontWeight500: {
    fontWeight: 500
  },
  font14: {
    fontSize: '14px'
  },
  dialogActions: {
    borderTop: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(2),
    '& > button': {
      margin: 0
    }
  }
}));
